import _styled4 from "../web_modules/styled-components.js";
import _styled3 from "../web_modules/styled-components.js";
import _styled2 from "../web_modules/styled-components.js";
import _styled from "../web_modules/styled-components.js";
import React from "../web_modules/react.js";
import { useLanguage } from "./app.js";
import { useTranslation } from "../web_modules/react-i18next.js";

var _StyledDiv = _styled("div").withConfig({
  displayName: "seating_details___StyledDiv",
  componentId: "sc-1hdkkqf-0"
})({
  display: "flex",
  justifyContent: "space-between"
});

var _StyledP = _styled("p").withConfig({
  displayName: "seating_details___StyledP",
  componentId: "sc-1hdkkqf-1"
})({
  fontSize: 10,
  margin: 0
});

var _StyledDiv2 = _styled("div").withConfig({
  displayName: "seating_details___StyledDiv2",
  componentId: "sc-1hdkkqf-2"
})({
  display: "flex",
  alignItems: "center"
});

var _StyledSpan = _styled("span").withConfig({
  displayName: "seating_details___StyledSpan",
  componentId: "sc-1hdkkqf-3"
})({
  fontSize: "10px"
});

export function SeatingDetails({
  seat,
  whitelabel,
  ticketType
}) {
  const {
    t
  } = useTranslation();
  const language = useLanguage(); // When a discount is applied, the new price can be 0

  const isFree = ticketType.is_free || ticketType.price === 0;
  return /*#__PURE__*/React.createElement(_StyledDiv, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, ticketType.title), /*#__PURE__*/React.createElement(_StyledP, null, seat.section && /*#__PURE__*/React.createElement("div", null, t("event.section"), ": ", seat.section, " "), seat.parentType && (seat.parentType === "table" ? t("event.table") + ": " + seat.parent : seat.parentType === "row" && t("event.row") + ": " + seat.parent), " ", seat.type === "GeneralAdmissionArea" ? "" : seat.type === "Booth" ? t("event.booth") + ": " : t("event.seat") + ": ", seat.label)), /*#__PURE__*/React.createElement(_StyledDiv2, null, isFree ? t("event.free").toLowerCase() : ticketType.price + " " + (language === "en" ? "DKK" : "kr"), !isFree && /*#__PURE__*/React.createElement(_StyledSpan, null, " ", "+ ", ticketType.fee, " ", language === "en" ? "DKK" : "kr")));
}